import { ToolsParameter, ToolsResponse } from '@/types/service-response'

export class Tools {
  public constructor (
    readonly code: string,
    readonly label: string,
    readonly question: string,
    readonly parameters: ToolsParameter[],
    readonly children: Tools[]
  ) {}

  static createFromResponse (responseData: ToolsResponse[]): Array<Tools> {
    let result: Array<Tools> = []
    if (responseData) {
      result = responseData.map((item: ToolsResponse ) => {
        return new Tools(
          item.Code ? item.Code : '',
          item.Bezeichnung ? item.Bezeichnung : '',
          item.Frage ? item.Frage : '',
        item.Parameters ? item.Parameters : [],
        item.Children ? Tools.createFromResponse(item.Children) : []
        )
      })
    }
    return result
  }
}
